import React from 'react';
import { CompassIcon, EyeIcon, RocketIcon, WrenchIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  compass: CompassIcon,
  wrench: WrenchIcon,
  eye: EyeIcon,
  rocket: RocketIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-white" data-id="element-16" data-mp="3nohvc9ve1qvt">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="38s0krkv0wgab">
        <h2 id="beneficios" className="font-display text-xl uppercase leading-tight text-brand-carbon sm:text-3xl" data-id="element-18" data-mp="38qpi5odbdeks">
          ¿Qué puede cambiar cuando empiezas?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-snug text-brand-muted" data-id="element-19" data-mp="2ztf7a44errge">
          Una habilidad técnica puede abrir nuevas posibilidades.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="y1ajn4txzgbh">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg bg-brand-steel p-3 text-left" data-id="element-21" data-mp="2bens1aj2y7kv" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-brand-yellow" data-id="element-22" data-mp="2l3xjqpa0ho8g">
                  <Icon size={15} className="text-brand-carbon" data-id="element-23" data-mp="2g6fmhw5cwxga" />
                </span>
                <div data-id="element-24" data-mp="1sh3363gbf909">
                  <h3 className="text-[0.8rem] font-extrabold uppercase leading-tight text-brand-navy" data-id="element-25" data-mp="1sgl8vcd7r4uz">
                    {benefit.title}
                  </h3>
                  <p className="mt-1 text-[0.78rem] leading-snug text-brand-muted" data-id="element-26" data-mp="22er81m7mxww5">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}